import type { Row, RowData, TableFeature } from '@tanstack/react-table';

export interface DataTableRowSelectionOptions<TData extends RowData> {
  /**
   * 행별로 Checkbox/Radio를 숨길지 결정합니다.
   * 숨긴 행은 선택 컬럼의 공간은 유지하지만 선택 컨트롤을 표시하지 않으며 선택 대상에서도 제외됩니다.
   *
   * @default undefined
   */
  hideRowSelection?: (row: Row<TData>) => boolean;
}

export interface DataTableRowSelectionRow {
  /**
   * 해당 행의 Checkbox/Radio가 숨김 상태인지 반환합니다.
   * Feature가 등록되지 않은 기존 Table 인스턴스와의 호환을 위해 optional 메서드로 제공합니다.
   */
  getIsSelectionHidden?: () => boolean;
}

declare module '@tanstack/react-table' {
  interface TableOptionsResolved<TData extends RowData>
    extends DataTableRowSelectionOptions<TData> {}

  // TanStack 원본 선언과 제네릭 이름이 같아야 합니다.
  // eslint-disable-next-line unused-imports/no-unused-vars
  interface Row<TData extends RowData> extends DataTableRowSelectionRow {}
}

export const RowSelection: TableFeature<unknown> = {
  createRow: (row, table) => {
    const getCanSelect = row.getCanSelect;

    row.getIsSelectionHidden = () => table.options.hideRowSelection?.(row) ?? false;
    row.getCanSelect = () => !(row.getIsSelectionHidden?.() ?? false) && getCanSelect();
  },
};
